import 'bootstrap/dist/css/bootstrap.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import store from './store';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Router } from 'react-router';
import { FrontContextProvider } from './providers/frontContext';

require('wavesurfer.js');
require('wavesurfer.js/dist/plugin/wavesurfer.timeline.min.js');
require('wavesurfer.js/dist/plugin/wavesurfer.regions.min.js');
require('wavesurfer.js/dist/plugin/wavesurfer.minimap.min.js');
// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

ReactDOM.render(
	<FrontContextProvider>
		<Provider store={store}>
			<Router history={history}>
				<App />
			</Router>
		</Provider>
	</FrontContextProvider>,
	document.getElementById('root'));

registerServiceWorker();